/* eslint-disable react/prop-types */
import React, { useState } from "react";

export const ErrorDisplay = ({
  errorTitle,
  errorContent,
  viewErrDetails,
  btnToHome,
  customClasses = {},
  errorSvg,
}) => {
  const [toggle, setToggle] = useState(false);

  return (
    <div
      className="bg-[#f5f3f0] flex items-center justify-center p-4"
      style={{ minHeight: "calc(100vh - 72px" }}
    >
      {/* Error Head */}
      <div className="text-center max-w-md mx-auto">
        {/* Error SVG */}
        <div className="mb-8 flex justify-center">{errorSvg}</div>

        {/* Title */}
        <h1
          className={`text-2xl font-bold text-gray-800 ${
            customClasses.errorTitleContainer || ""
          }`}
        >
          {errorTitle}
        </h1>

        {/* Content */}
        <p
          className={`text-gray-600 text-base ${
            customClasses.errorContentContainer || ""
          }`}
        >
          {errorContent}
        </p>

        {/* Back to Home Button */}
        {btnToHome && (
          <div className="mt-4">
            <button
              type="button"
              onClick={() => {
                // eslint-disable-next-line no-return-assign
                return (window.location.href = "/");
              }}
              className={`bg-[#927940] hover:bg-[#8f6b47] text-white px-6 py-2 rounded-md font-medium transition-colors duration-200 flex items-center gap-2 mx-auto ${
                customClasses.btnToHome || ""
              }`}
            >
              Back to Home Page
            </button>
          </div>
        )}

        {/* View / Hide Details Toggle */}
        {viewErrDetails && (
          <div className="mt-4">
            <button
              type="button"
              onClick={() => {
                return setToggle(!toggle);
              }}
              className="text-blue-600 underline text-lg focus:outline-none"
            >
              {toggle ? "Hide Details" : "View Details"}
            </button>
          </div>
        )}

        {/* Toggle Content */}
        {toggle && (
          <div className="mt-3 text-gray-600 text-base text-center">
            {viewErrDetails}
          </div>
        )}
      </div>
    </div>
  );
};

ErrorDisplay.defaultProps = {
  errorTitleContainer: "",
  btnToHome: "",
  errorContentContainer: "",
};
